import { useEffect } from "react";
import { PayPalMessages, usePayPalScriptReducer } from "@paypal/react-paypal-js";

const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

// Single shared SDK config: buttons + messages must load from the same script to avoid SDK conflicts
export const PAYPAL_SDK_OPTIONS = {
  clientId: CLIENT_ID,
  currency: "EUR",
  intent: "capture",
  components: "buttons,messages",
  enableFunding: "paylater",
};

// Loads the app-wide PayPal SDK on first use (provider is mounted once in App.js with deferLoading)
export const usePayPalSdk = () => {
  const [{ isInitial, isResolved, isRejected }, dispatch] = usePayPalScriptReducer();
  useEffect(() => {
    if (isInitial && CLIENT_ID) dispatch({ type: "setLoadingStatus", value: "pending" });
  }, [isInitial, dispatch]);
  return { isResolved, isRejected };
};

/** PayPal "Paga in 3 rate" message; PayPal shows it only for eligible amounts (30€–2.000€). */
export default function PayPalPayLater({ amount, theme: themeProp, testid = "paypal-paylater" }) {
  const value = Number(amount) || 0;
  const eligible = !!CLIENT_ID && value >= 30 && value <= 2000;
  const theme = themeProp || (document.querySelector(".public-light") ? "black" : "white");
  const { isResolved } = usePayPalSdk();
  if (!eligible || !isResolved) return null;
  return (
    <div data-testid={testid} className="mt-3 min-h-[22px]">
        <PayPalMessages
          amount={value.toFixed(2)}
          currency="EUR"
          style={{ layout: "text", logo: { type: "inline" }, text: { color: theme, size: 13 } }}
        />
    </div>
  );
}
